
import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { ProductDefinition, ProductType, Query, Ticket } from 'core-lib';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PaymentLibService {


  constructor(private apollo: Apollo) { }


  PRODUCT_PROPERTIES = `id
  name
  active
  description
  paymentProviderReference{
    refId
    environment
  }
  tax{
    rate
  }
  image {
    url
  }
  type
  preventStockpile
  price{
    id
    currency
    amount
  }`;

  QUERY_WALLET = gql`
  query wallet{
    wallet {
      id
      product{
        ${this.PRODUCT_PROPERTIES}
      }
      validFrom
      validTo
      usageCount
      usageLimit
  }}`;

  QUERY_PRODUCT_DEFINITIONS = gql`
  query listProducts{
    listProducts {
      ${this.PRODUCT_PROPERTIES}
  }}`;

  QUERY_PRODUCTS_BY_TYPES = gql`
  query listProductsByTypes($types : [ProductType], $onlyActive: Boolean){
    listProductsByTypes(types: $types, onlyActive: $onlyActive) {
      ${this.PRODUCT_PROPERTIES}
  }}`;



  QUERY_PRODUCT_BY_IDS = gql`
  query listProductsByIds($ids : [ID]){
    listProductsByIds(ids:$ids) {
      ${this.PRODUCT_PROPERTIES}
  }}`;


  /**
   * load the wallet from the server
   * @returns 
   */
  loadWallet(): Observable<Ticket[]> {
    return this.apollo.query<Query>({
      query: this.QUERY_WALLET,
    }).pipe(map(r => r.data.wallet));
  }


  /**
 * load the wallet from the server
 * @returns 
 */
  loadProductDefinitions(): Observable<ProductDefinition[]> {
    return this.apollo.query<Query>({
      query: this.QUERY_PRODUCT_DEFINITIONS,
    }).pipe(map(r => r.data.listProducts));
  }

  /**
   * list products by types
   * @param types 
   * @returns 
   */
  listProductsByTypes(types: ProductType[],onlyActive: boolean): Observable<ProductDefinition[]> {
    return this.apollo.query<Query>({
      query: this.QUERY_PRODUCTS_BY_TYPES,
      variables:{
        types,
        onlyActive
      }
    }).pipe(map(r => r.data.listProductsByTypes));
  }

  /**
 * load the wallet from the server
 * @returns 
 */
  listProductsByIds(ids: string[]): Observable<ProductDefinition[]> {
    return this.apollo.query<Query>({
      query: this.QUERY_PRODUCT_BY_IDS,
      variables: {
        ids
      }
    }).pipe(map(r => r.data.listProductsByIds));
  }

}
